import React from 'react';
import ErrorPage from './ErrorPage';

export default function Error404Page() {
  return <ErrorPage title="Not Found">Sorry, but the page you were trying to view does not exist.</ErrorPage>;
}



// WEBPACK FOOTER //
// ./modules/Errors/components/Error404Page.js